import type { WordCharacterBack } from "#use-word-character-backs-query";
import { hasLength } from "@-/com.npmjs.ts-array-length";

/**
 * The expected answer for a word card: each character's back, in word order, joined by spaces.
 *
 * A word is drilled as "which characters spell this?", and the back shows one tile per character
 * with that character's own meaning beneath it. The answer is therefore the concatenation of
 * those same per-character meanings — `睡觉` expects `"sleep sleep"`-style input built from
 * `睡`'s back plus `觉`'s back, and a three-character word expects three parts.
 *
 * Returns `null` when ANY character has no back. A partial answer would be ungradeable: the user
 * cannot supply a meaning the app does not have, so accepting a shortened string would mark
 * correct answers wrong. Callers treat `null` as "no typed answer available" and fall back to
 * tap-to-reveal.
 */
export function buildWordSentenceExpectedAnswer(
  characterBacks: readonly WordCharacterBack[],
): string | null {
  if (hasLength(characterBacks, 0)) {
    return null;
  }
  const expectedAnswerParts: string[] = [];
  for (const { back } of characterBacks) {
    if (back === null || back.length === 0) {
      return null;
    }
    expectedAnswerParts.push(back);
  }
  return expectedAnswerParts.join(" ");
}
